import { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { RecordVoiceOver } from '@mui/icons-material';
import eventBus, { eventBusValues } from '../eventBus';
import { useAccount } from '../contexts/Account';
import ACSnackbar from './ACSnackbar';
import NativeShare from './Company/ShareItems/NativeShare';
import { useHistory } from 'react-router-dom';
import LinkedInLogo from './Company/ShareItems/linked_In_logo.svg';

export default function ShareItemsMultiAccount({ isAdvisor }) {
  const [snackbar, setSnackbar] = useState(false);
  const { currentPlan, isFreeTrial, isImpersonated, accountDetails } =
    useAccount();
  const history = useHistory();
  const maxAdvisorCount = currentPlan?.maxAdvisorCount;
  const currentAdvisorCount =
    accountDetails?.boardAdvisors?.filter(
      (advisor) => advisor.advisorStatus === 'active'
    ).length || 0;

  const showScreen =
    currentAdvisorCount >= maxAdvisorCount && maxAdvisorCount !== null;

  const validateMaxAdvisors = (functionToCall) => {
    if (isAdvisor) return true;
    if (currentAdvisorCount >= maxAdvisorCount && maxAdvisorCount !== null) {
      if (isFreeTrial && !isImpersonated) {
        eventBus.dispatch(eventBusValues.triggerCompanyUpgradeAction, {
          action: functionToCall,
        });
      } else {
        history.push('/ub/' + currentPlan.maxAdvisorGateUrl);
      }
      return false;
    } else {
      return true;
    }
  };

  const handleLinkedInShare = async () => {
    eventBus.dispatch('openLinkedInPostModal');
  };

  const handleFacebookShare = () => {
    const isValid = validateMaxAdvisors(() => {
      eventBus.dispatch('openCopyModal', {
        modalType: 'facebook',
      });
    });
    if (!isValid) return;
    eventBus.dispatch('openCopyModal', {
      modalType: 'facebook',
    });
  };

  const handleXShare = () => {
    const isValid = validateMaxAdvisors(() => {
      eventBus.dispatch('openCopyModal', {
        modalType: 'x',
      });
    });
    if (!isValid) return;
    eventBus.dispatch('openCopyModal', {
      modalType: 'x',
    });
  };

  const handleCopyShare = () => {
    const isValid = validateMaxAdvisors(() => {
      eventBus.dispatch('openCopyModal');
    });
    if (!isValid) return;
    eventBus.dispatch('openCopyModal');
  };

  const handleEmailShare = () => {
    const isValid = validateMaxAdvisors(() => {
      eventBus.dispatch('openEmailModal', {
        modalType: 'email',
      });
    });
    if (!isValid) return;
    eventBus.dispatch('openEmailModal', {
      modalType: 'email',
    });
  };

  const iconStyle = {
    margin: '0 10px',
    cursor: 'pointer',
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xxs: 'column', xs: 'row' }}
      alignItems="center"
      justifyContent={{ xxs: 'center', sm: 'flex-start' }}
      mt={2}
      id="dashboard-invite-buttons"
    >
      <Box display="flex" alignItems="center" mb={{ xxs: 2, xs: 0 }}>
        <RecordVoiceOver
          sx={{
            color: '#4FB5F9',
            mr: '8px',
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            mr: '7px',
          }}
        >
          {isAdvisor ? 'Promote Profile:' : 'Invite Contacts'}
        </Typography>
      </Box>
      <Box>
        <img
          src={LinkedInLogo}
          alt="Linked In Logo"
          id="dashboard-invite-linkedin"
          style={iconStyle}
          onClick={handleLinkedInShare}
        />
        <img
          src="/icons/facebook_logo.svg"
          id="dashboard-invite-facebook"
          alt="Facebook Logo"
          style={iconStyle}
          onClick={handleFacebookShare}
        />
        <img
          src="/icons/x_logo.svg"
          id="dashboard-invite-x"
          alt="X Logo"
          style={iconStyle}
          onClick={handleXShare}
        />
        <Box sx={{ display: 'inline-block', position: 'relative' }}>
          {showScreen && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                zIndex: 2,
                cursor: 'pointer',
                width: '100%',
                height: '100%',
                background: 'transparent',
              }}
              onClick={(e) => {
                const isValid = validateMaxAdvisors(() => {});
                if (!isValid) {
                  e.stopPropagation();
                  e.preventDefault();
                }
              }}
            />
          )}

          <NativeShare
            iconStyle={iconStyle}
            ids={{ message: 'dashboard-invite-message' }}
          />
        </Box>
        <img
          src="/icons/web_logo.svg"
          alt="Web Logo"
          id="dashboard-invite-copy"
          style={{ ...iconStyle, width: '27px', height: '27px' }}
          onClick={handleCopyShare}
        />
        <img
          src="/icons/email_icon.svg"
          alt="Email Logo"
          id="dashboard-invite-email"
          style={iconStyle}
          onClick={handleEmailShare}
        />
      </Box>
      {isAdvisor && (
        <Box
          id="dashbaordGetFeaturedCta"
          sx={{
            backgroundColor: '#F1F9FF',
            padding: '4px 14px',
            borderRadius: '8px',
            border: '1px solid #4FB5F9',
            mx: { xxs: 0, xs: 1 },
            mt: { xxs: 2, xs: '-6px' },
            cursor: 'pointer',
            width: { xxs: '90%', xs: 'fit-content' },
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '24px',
              textAlign: 'center',
            }}
          >
            🚀 Get Featured
          </Typography>
        </Box>
      )}
      <ACSnackbar
        open={snackbar}
        text="Link copied, you can now share it with whoever you choose"
        severity="success"
        onClose={() => setSnackbar(false)}
        autoHideDuration={6000}
      />
    </Box>
  );
}
